module.exports = __webpack_public_path__ + "img/line-chart-up-02.42d88bdf.svg";